import { QuestionnaireItem } from './QuestionnaireCRUD.utils';

/** Skeleton / field-dictionary XPath for a questionnaire item (Item1, Item2, ...). */
export function getQuestionnaireItemFieldKey(itemIndex: number): `Item${number}` {
    return `Item${itemIndex + 1}`;
}

export function getQuestionnaireAnswerFieldKeys(items: QuestionnaireItem[]): string[] {
    return items.map((item, index) => getQuestionnaireItemFieldKey(index));
}
